import { render, staticRenderFns } from "./AgentDetailBox.vue?vue&type=template&id=15ddb599&scoped=true"
import script from "./AgentDetailBox.vue?vue&type=script&lang=js"
export * from "./AgentDetailBox.vue?vue&type=script&lang=js"
import style0 from "./AgentDetailBox.vue?vue&type=style&index=0&id=15ddb599&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ddb599",
  null
  
)

export default component.exports